import { Mark } from '@tiptap/core';
import { extractStylesFromMarkComponent } from './extractStyles';
export const createSuggestionAddMark = (options) => {
    // Extract styles once when creating the mark
    const extractedStyle = extractStylesFromMarkComponent(options.MarkComponent, 'apply');
    return Mark.create({
        name: 'suggestionAdd',
        addAttributes() {
            return {
                suggestionId: {
                    default: null,
                },
            };
        },
        parseHTML() {
            return [
                {
                    tag: 'span[data-suggestion-add]',
                },
            ];
        },
        renderHTML({ HTMLAttributes }) {
            const styleString = Object.entries(extractedStyle)
                .map(([key, value]) => {
                // Convert camelCase to kebab-case
                const kebabKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
                return `${kebabKey}: ${value}`;
            })
                .join('; ');
            return [
                'span',
                {
                    ...HTMLAttributes,
                    'data-suggestion-add': '',
                    style: styleString,
                },
                0,
            ];
        },
    });
};
export const createSuggestionDeleteMark = (options) => {
    // Extract styles once when creating the mark
    const extractedStyle = extractStylesFromMarkComponent(options.MarkComponent, 'reject');
    return Mark.create({
        name: 'suggestionDelete',
        addAttributes() {
            return {
                suggestionId: {
                    default: null,
                },
            };
        },
        parseHTML() {
            return [
                {
                    tag: 'span[data-suggestion-delete]',
                },
            ];
        },
        renderHTML({ HTMLAttributes }) {
            const styleString = Object.entries(extractedStyle)
                .map(([key, value]) => {
                // Convert camelCase to kebab-case
                const kebabKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
                return `${kebabKey}: ${value}`;
            })
                .join('; ');
            return [
                'span',
                {
                    ...HTMLAttributes,
                    'data-suggestion-delete': '',
                    style: styleString,
                },
                0,
            ];
        },
    });
};
//# sourceMappingURL=suggestionMarks.js.map